export default __webpack_public_path__ + "images/M8.bc7d000.png";